import { NominationRole } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateProgramCountryNominationRole: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  nominationRole: NominationRole,
  accessToken?: string,
) => Promise<void> = async (fetchContext, programId, countryId, nominationId, nominationRole, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/role`,
  {
    method: 'PUT',
    body: JSON.stringify(nominationRole),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update program country nomination role'));
